import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './admin/auth.service';

import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  public user$:Observable <any> = this._auth._authfb.user;
  detailUser;

  constructor(
    private _auth: AuthService,
    analytics: AngularFireAnalytics
    ) {
      
     }

  ngOnInit() {
   }
}
